export default __webpack_public_path__ + "static/media/logo_jalisco_se_defiende_dark.0a6f4399.svg";